import icon from 'assets/icons/ico_map_marker.svg';
import L from 'leaflet';

export const Icon = new L.Icon({
  iconUrl: icon,
  iconSize: new L.Point(50, 50),
  iconAnchor: [28, 45]
  //popupAnchor: [2, -40],
});
